import { render } from "./StatusCountsWidget.vue?vue&type=template&id=164cb8e1"
import script from "./StatusCountsWidget.vue?vue&type=script&lang=js"
export * from "./StatusCountsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__